export interface OverviewPaginationMeta {
   current_page: number;
   per_page: number;
   total: number;
   last_page: number;
   from: number | null;
   to: number | null;
}

export function isOverviewPaginationMeta(value: unknown): value is OverviewPaginationMeta {
   if (!value || typeof value !== 'object') return false;
   const meta = value as OverviewPaginationMeta;
   return (
      typeof meta.current_page === 'number' &&
      typeof meta.per_page === 'number' &&
      typeof meta.total === 'number' &&
      typeof meta.last_page === 'number'
   );
}
